module.exports = __webpack_public_path__ + "img/dosing-icon.bd74b395.png";